var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_vm._v(" 左のメニューから管理する項目を選択してください。 ")])}
var staticRenderFns = []

export { render, staticRenderFns }